const config = {
  apiURL: import.meta.env.VITE_API_URL,
  mode: import.meta.env.VITE_MODE,
  siteKey: import.meta.env.VITE_REACT_APP_SITE_KEY,
  siemensIdLoginUrl: import.meta.env.VITE_SIEMENS_ID_LOGIN_URL,
}

console.log(config)

export const APP_MODE = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PREPROD: 'preprod',
  PRODUCTION: 'production',
}

export default config
